import { render, staticRenderFns } from "./AccountBook.vue?vue&type=template&id=2204d1b6&scoped=true&lang=pug&"
import script from "./AccountBook.vue?vue&type=script&lang=js&"
export * from "./AccountBook.vue?vue&type=script&lang=js&"
import style0 from "./AccountBook.vue?vue&type=style&index=0&id=2204d1b6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2204d1b6",
  null
  
)

export default component.exports